import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/digitalComponent/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/digitalComponent/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/digitalComponent/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/digitalComponent/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/digitalComponent/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/digitalComponent/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/digitalComponent/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/digitalComponent/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/digitalComponent/UPDATE_FAILURE'

// Initial State
const initialState = {
  loaded: false,
  loadedIds: [],
  loading: false,
  creating: false,
  updating: false,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadDigitalComponents(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/admin/digital_components.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIGITAL_COMPONENT_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function loadDigitalComponent(digitalComponent, options){
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.digitalComponents.loadedIds ? state.digitalComponents.loadedIds.slice() : []
    if (!loadedIds.includes(digitalComponent.id)){
      loadedIds.push(digitalComponent.id)
    }

    dispatch(fetchRequest({ loadedIds }))

    const promise = api(`/admin/digital_components/${digitalComponent.id}.json`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIGITAL_COMPONENT)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createDigitalComponent(digitalComponent, options, successCallback, errorCallback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      digital_component: digitalComponent,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/digital_components.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIGITAL_COMPONENT)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (successCallback) successCallback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))

        if (errorCallback) errorCallback(errors)
      })

    return promise
  }
}

export function updateDigitalComponent(digitalComponent, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      digital_component: digitalComponent,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/digital_components/${digitalComponent.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.DIGITAL_COMPONENT)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
